import styled from 'styled-components';
import SectionContainer from '@common/components/SectionContainer';
import { media } from 'styled-bootstrap-grid';

export const RoomWrapper = styled(SectionContainer)`
  margin-top: 10px;
`;

export const MarkdownWrapper = styled.div`
  padding-top: 24px;
`;
export const ScrollButtonWrapper = styled.div`
  display: none;

  button {
    width: 100%;
  }

  ${media.xs`
    margin-top: 1rem;
    display: block;
  `}
`;

export const Columns = styled.ul`
  columns: 1;
  padding-left: 20px;
  li {
    margin-right: 48px;
  }

  ${media.sm`
    columns:2;
  `}
`;
